import { CheckCircle2 } from "lucide-react";

const points = [
  "Wheelchair lift–equipped vehicles maintained to the highest standard",
  "Drivers trained in safe transfers, securement, and patient sensitivity",
  "Door-through-door service — we help you safely from inside your home",
  "Recurring schedules for dialysis, rehab, and ongoing treatments",
];

export default function About() {
  return (
    <section data-testid="about-section" id="about" className="section-pad">
      <div className="container-pad mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -top-8 -left-8 w-24 h-24 border-2 border-teal-500/20 rounded-3xl" />
              <img
                src="https://customer-assets.emergentagent.com/job_comfort-care-booking/artifacts/5h7vb5gv_Screenshot%202026-06-05%20at%209.17.55%E2%80%AFAM.png"
                alt="Compassionate caregiver assisting senior woman in wheelchair at medical facility"
                className="rounded-3xl w-full h-[520px] object-cover relative shadow-[0_30px_80px_-30px_rgba(10,25,47,0.3)]"
              />
              <div className="absolute -bottom-6 -right-6 bg-sand p-6 rounded-2xl shadow-xl max-w-[220px] border border-sand-200">
                <div className="text-4xl font-heading font-bold text-teal-600">500+</div>
                <div className="text-xs text-navy/70 mt-1">Families served safely across Virginia</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <span className="eyebrow">
              <span className="w-8 h-px bg-teal-500" />
              About Comfort Care
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-navy tracking-tight mt-5 leading-[1.15]">
              Transportation you can <strong className="font-bold text-teal-600">truly trust.</strong>
            </h2>
            <p className="mt-6 text-base md:text-lg text-navy/70 leading-relaxed font-light">
              At Comfort Care Transportation, we understand that getting to medical appointments safely is essential.
              Whether you're attending a routine doctor visit, dialysis treatment, physical therapy session, or returning
              home after a hospital stay, our team provides dependable transportation with compassion and professionalism.
            </p>
            <p className="mt-4 text-base md:text-lg text-navy/70 leading-relaxed font-light">
              We focus on <strong className="font-medium text-navy">comfort, safety, punctuality, and dignity</strong> for
              every passenger.
            </p>

            <ul className="mt-8 space-y-4">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-teal-500 mt-0.5 shrink-0" />
                  <span className="text-navy/85">{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
